export enum Modes {
  default = 'DEFAULT',
  rightSlide = 'RIGHT_SLIDE',
}
